"use client";

import { Button } from "@oreme/ui";
import { CloudSun, ExternalLink } from "lucide-react";
import Link from "next/link";
import { useTranslations, useLocale } from "next-intl";
import React, { type ReactElement } from "react";

interface WeatherPanelLegendProps {
  counter: number;
}

function WeatherPanelLegend({
  counter,
}: Readonly<WeatherPanelLegendProps>): ReactElement {
  const t = useTranslations("weather.PanelLegend");
  const locale = useLocale();
  const lastUpdate = new Date(Date.UTC(2024, 1, 20, 18, 0, 0));

  return (
    <div className="flex flex-col gap-2 absolute z-10 top-3 left-3 p-3 text-sm border border-border rounded-lg bg-background shadow-md drop-shadow-md">
      <header className=" flex flex-row gap-2 items-center justify-between">
        <div className="flex flex-row gap-2 items-center">
          <CloudSun size={20} />
          <span className="text-2xl">{counter}</span>
          <span>{t("station", { count: counter })}</span>
        </div>
      </header>
      <dl className="flex flex-row gap-1 p-1 m-0 text-xs text-muted-foreground border border-border rounded">
        <dt>{t("lastUpdate", { date: "" })}</dt>
        <dd>
          <time>{lastUpdate.toLocaleString(locale, { timeZone: "UTC" })}</time>
        </dd>
      </dl>
      <footer>
        <Link
          href="https://meteo.data.gouv.fr/datasets/656dab84db1bdf627a40eaae"
          target="_blank"
        >
          <Button className="w-full" size="sm">
            {t("viewDatasets")} <ExternalLink size={16} />
          </Button>
        </Link>
      </footer>
    </div>
  );
}

export { WeatherPanelLegend, type WeatherPanelLegendProps };
